module.exports = __webpack_public_path__ + "static/media/call_I.7b963b99.svg";